import React from 'react';
import { ShadowAroundStyled, ContainerStyled, LabelStyled, SquareStyled } from './style';
import { useLoginContext } from 'context/login-context';

const CheckboxLogin = () => {
  const { checkboxTerms, setCheckboxTerms, setShowTermsUse, } = useLoginContext();

  const handleCheckboxChange = () => {
    setCheckboxTerms({ ...checkboxTerms, isChecked: !checkboxTerms.isChecked });
  };

  const abrirTermosDeUso = (event) => {
    event.stopPropagation();
    setCheckboxTerms({
      ...checkboxTerms,
      showCheckbox: false,
    });
    setShowTermsUse(true);
  }

  return (
    <ContainerStyled>
      <input
        type='checkbox'
        id='checkbox-aceitar-termos'
        name='termosUso'
        checked={checkboxTerms.isChecked}
      />

      <LabelStyled htmlFor='termosUso' onClick={handleCheckboxChange}>
        <ShadowAroundStyled />
        <SquareStyled
          isChecked={checkboxTerms.isChecked}
          onClick={handleCheckboxChange}
        />
        Li e concordo com os
        <span className='link-termos-uso' onClick={abrirTermosDeUso}>Termos de uso</span>
      </LabelStyled>

    </ContainerStyled>
  );
}
export default CheckboxLogin;

